import { CaseStudy } from '../../types';

export const xtras: CaseStudy = {
  id: '11',
  title: 'Xtras',
  category: 'Gig Worker Toolkit',
  imageUrl: 'https://images.unsplash.com/photo-1521791055366-0d553872125f?q=80&w=1200&auto=format&fit=crop',
  description: 'Essential utilities for the modern freelancer. From mile-tracking to invoice generation, Xtras handles the admin so you can focus on the work.',
  screenshots: [],
  comingSoon: true
};